import { createAction, props } from '@ngrx/store';

import { MultiAccordionId } from '../../reducers/multi-terms-accordion/multi-terms-accordion.reducer';

export const acceptMultiAccordion = createAction(
  '[Multi Terms Accordion] Accept Accordion',
  props<{ accordionId: MultiAccordionId; acceptedAt: string }>(),
);

export const unacceptMultiAccordion = createAction(
  '[Multi Terms Accordion] Unaccept Accordion',
  props<{ accordionId: MultiAccordionId }>(),
);

export const setExpandedMultiAccordion = createAction(
  '[Multi Terms Accordion] Set Expanded Accordion',
  props<{ accordionId: MultiAccordionId | null }>(),
);

export const resetMultiAccordionState = createAction(
  '[Multi Terms Accordion] Reset Accordion State',
);
